import { render, staticRenderFns } from "./ButtonNew.vue?vue&type=template&id=13ec0465"
import script from "./ButtonNew.vue?vue&type=script&lang=js"
export * from "./ButtonNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports